import { render, staticRenderFns } from "./SongDetailsEditButton.vue?vue&type=template&id=bfce3a5e&scoped=true"
import script from "./SongDetailsEditButton.vue?vue&type=script&lang=ts"
export * from "./SongDetailsEditButton.vue?vue&type=script&lang=ts"
import style0 from "./SongDetailsEditButton.vue?vue&type=style&index=0&id=bfce3a5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfce3a5e",
  null
  
)

export default component.exports